/**
 * Layout común a todas las pantallas públicas de auth.
 *
 * Centra contenido en columna estrecha, fondo grafito, marca arriba.
 */
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { t } from "@/i18n/es";

interface Props {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: Props) {
  return (
    <main className="flex min-h-app items-center justify-center overflow-x-hidden bg-graphite px-6 py-12 text-bone">
      <div className="w-full max-w-sm">
        <p className="mb-10 text-xs uppercase tracking-widest text-gray-mid">
          {t.app.name.toLowerCase()}
        </p>
        <h1 className="mb-2 text-2xl font-medium tracking-tight">{title}</h1>
        {subtitle && (
          <p className="mb-8 text-sm text-bone-muted">{subtitle}</p>
        )}
        {!subtitle && <div className="mb-8" />}
        {children}
        {footer && <div className="mt-8 text-sm text-gray-mid">{footer}</div>}
        {/* S14.2 (R1 GDPR): acceso a las páginas legales públicas, presente
            en todas las pantallas de auth (login + registro). El enlace
            inline en el form de registro lo añade R2. */}
        <div
          data-testid="auth-legal-links"
          className="mt-10 flex justify-center gap-3 text-xs text-gray-mid"
        >
          <Link to="/privacy" className="hover:text-bone">
            {t.legal.footerPrivacy}
          </Link>
          <span aria-hidden="true">·</span>
          <Link to="/terms" className="hover:text-bone">
            {t.legal.footerTerms}
          </Link>
        </div>
      </div>
    </main>
  );
}
